import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { Chips } from '../../../../ui/Chips';
import { chipsStyles, OptionsWrapper } from '../styled';
import { FormErrorField } from '../FormErrorField';

const rentTypes = [
  {
    value: 'false',
    name: 'new_search.long_term',
    id: 'new-ad-form-long-term'
  },
  {
    value: 'true',
    name: 'search.form.paid_daily',
    id: 'new-ad-form-paid-daily'
  }
];

export const RentalType: React.FC = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const value = values[FORM_VALUES.paidDaily]?.toString();

  const onClick = (newValue: string) => {
    change(FORM_VALUES.paidDaily, newValue);
  };

  return (
    <div>
      <OptionsWrapper>
        {rentTypes.map(type => (
          <Chips
            key={type.id}
            type="button"
            hasCustomOnChange
            text={t(type.name)}
            storedValue={value}
            value={type.value}
            cypress={type.id}
            onClick={() => onClick(type.value)}
            styles={chipsStyles}
            isTextPadding={false}
          />
        ))}
      </OptionsWrapper>
      <FormErrorField
        cypress="paid-daily-field-error"
        field={FORM_VALUES.paidDaily}
      />
    </div>
  );
};
